// En sida i kontot: rubriken, sidans titel och fokus. Efter en navigering
// till sidan flyttas fokus till rubriken, så att en skärmläsare läser upp den
// nya sidan. När sidan laddas första gången börjar fokus överst, som vanligt,
// och flikar inom sidan flyttar inte fokus.
import { useEffect, useRef, type ReactNode } from 'react';
import { useLocation } from 'react-router';

/**
 * Platsen när kontot laddades. Webbläsaren behåller platsens nyckel vid en
 * omladdning, så nyckeln jämförs med den första i just den här sidladdningen.
 */
let startnyckel: string | undefined;

export function Sida({
  titel,
  bredvid,
  brodsmulor,
  children,
}: {
  titel: string;
  /** Visas bredvid rubriken, till exempel en status. */
  bredvid?: ReactNode;
  /** Vägen tillbaka, ovanför rubriken. */
  brodsmulor?: ReactNode;
  children: ReactNode;
}) {
  const rubrik = useRef<HTMLHeadingElement>(null);
  const { key } = useLocation();
  startnyckel ??= key;
  const nuvarande = useRef(key);
  nuvarande.current = key;
  useEffect(() => {
    document.title = `${titel} – LeadLedger`;
    if (nuvarande.current !== startnyckel) rubrik.current?.focus();
  }, [titel]);
  return (
    <main className="sida" id="innehall">
      {brodsmulor}
      <div className="rubrikrad">
        <h1 ref={rubrik} tabIndex={-1}>
          {titel}
        </h1>
        {bredvid}
      </div>
      {children}
    </main>
  );
}
